<template lang="html">
  <div class="content_block" :class="{ 'content_block-editable' : controls, 'content_block--bg' : bg }">
    <slot></slot>

    <div v-if="controls" class="content_block__btns">

      <button class="btn btn-sm btn-success btns__btn-save"
              v-if="edit"
              @click.prevent="saveAndClose()"><fa icon="save" fixed-width /></button>

      <button class="btn btn-sm btn-warning btns__btn-edit"
              @click.prevent="editBlock()"
              v-if="!edit"><fa icon="pencil-alt" fixed-width /></button>

      <button class="btn btn-sm btn-danger btns__btn-remove"
              @click.prevent="deleteBlock()"
              v-if="!edit"><fa icon="times" fixed-width /></button>

      <button class="btn btn-sm btn-default btns__btn-move handle"
              @click.prevent=""
              v-if="!edit"><fa icon="arrows-alt" fixed-width /></button>
    </div>
  </div>
</template>

<script>
import CKEditor from '~/components/global/CKEditor'

export default {
  components: {
    CKEditor
  },
  name: "ContentBlock",
  props: {
    controls: {
      type: Boolean,
      default: false
    },
    fresh: {
      type: Boolean,
      default: false
    },
    bg: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      edit: false
    }
  },
  mounted () {
    if (this.fresh) {
      this.edit = true;
    }
  },
  methods: {
    editBlock() {
      if (this.controls && !this.edit) {
        this.edit = true;
        this.$emit('edit');
      }
    },
    deleteBlock () {
      this.$emit('remove')
    },
    saveChanges() {
      this.$emit('input')
    },
    saveAndClose() {
      this.edit = false;
      this.$emit('input');
    }
  }
}
</script>
